import React, { useState, useEffect } from "react";
import { useGetWheelRewardsWonQuery, useUpdateWheelRewardWonStatusMutation, useAddCashTransferToBankMutation, useApproveWheelPointsRewardMutation } from "../../../features/wheel/wheelRewardsWonAPI";
import { FaGift, FaSearch, FaCalendarAlt, FaUser, FaMapMarkerAlt, FaTimes, FaImage } from "react-icons/fa";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
const WheelRewardsWon = () => {
    const [campaignId, setCampaignId] = useState("");
    const [photoModal, setPhotoModal] = useState({ open: false, url: "", name: "" });
    const [mapModal, setMapModal] = useState({ open: false, address: "", name: "", lat: null, lng: null });
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);

    const [activeTab, setActiveTab] = useState("Gift");
    const [filteredStatus, setFilteredStatus] = useState("");

    const tabs = [
        { id: 1, name: "Filler" },
        { id: 2, name: "Gift" },
        { id: 3, name: "Cashback" },
        { id: 4, name: "Points" },
    ];

    const [updateStatus] = useUpdateWheelRewardWonStatusMutation();
    const [addCashTransfer] = useAddCashTransferToBankMutation();
    const [approvePoints] = useApproveWheelPointsRewardMutation();

    const handleUpdateStatus = async (id, newStatus) => {
        try {
            const res = await updateStatus({ id, status: newStatus }).unwrap();
            if (res.status) {
                window.alert("Status updated successfully");
            } else {
                window.alert(res.message || "Failed to update status");
            }
        } catch (err) {
            console.error("Error updating status:", err);
            window.alert("An error occurred while updating status");
        }
    };

    const handleApprove = async (row) => {
        if (activeTab === "Cashback") {
            try {
                const payload = {
                    app_user_id: row.app_user_id,
                    bene_id: row.cash_upi_address,
                    cash: row.reward_price,
                    wr_id: row.id,
                };
                const res = await addCashTransfer(payload).unwrap();
                if (res.status) {
                    window.alert("Cashback transfer initiated successfully");
                    // Optionally update status to approved (0) if the backend doesn't do it automatically
                    // await handleUpdateStatus(row.id, 0);
                } else {
                    window.alert(res.message || "Failed to initiate cash transfer");
                }
            } catch (err) {
                console.error("Error in cash transfer:", err);
                window.alert("An error occurred while initiating cash transfer");
            }
        }
 else if (activeTab === "Points") {
            try {
                const res = await approvePoints(row.id).unwrap();
                if (res.status) {
                    window.alert("Points reward approved successfully");
                } else {
                    window.alert(res.message || "Failed to approve points reward");
                }
            } catch (err) {
                console.error("Error approving points:", err);
                window.alert("An error occurred while approving points reward");
            }
        } else {
            await handleUpdateStatus(row.id, 0);
        }
    };

    // Fetch wheel rewards won data

    const {
        data: rewardsWonData,
        error,
        isLoading,
        refetch,
    } = useGetWheelRewardsWonQuery({
        wc_id: campaignId,
        page,
        limit,
        search,
        reward_type: activeTab,
        status: filteredStatus,
    });



    const columns = [
        {
            name: "ID",
            selector: (row) => row.id,
            sortable: true,
            width: "80px",
        },
        {
            name: "User Photo",
            cell: (row) => row.selfieurl ? (
                <button
                    onClick={() => setPhotoModal({ open: true, url: row.selfieurl, name: row.user_name || "User" })}
                    className="focus:outline-none group"
                    title="View selfie"
                >
                    <img
                        src={row.selfieurl}
                        alt={row.user_name || "User selfie"}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid #6366f1",
                            cursor: "pointer",
                            transition: "transform 0.2s",
                        }}
                        onMouseOver={e => e.currentTarget.style.transform = "scale(1.15)"}
                        onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                    />
                </button>
            ) : (
                <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FaImage style={{ color: "#6366f1", fontSize: 18 }} />
                </div>
            ),
            width: "90px",
            ignoreRowClick: true,
        },
        {
            name: "Campaign",
            selector: (row) => row.campaign_name || "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: "Reward Name",
            selector: (row) => row.reward_name || row.text || "Unknown",
            sortable: true,
            width: "180px",
        },
        {
            name: "Type",
            selector: (row) => row.reward_type || "N/A",
            sortable: true,
            width: "100px",
        },
        {
            name: "Price",
            selector: (row) => row.reward_price ? `₹${row.reward_price}` : "0",
            sortable: true,
            width: "100px",
        },
        {
            name: "User Name",
            selector: (row) => row.user_name || "Guest",
            sortable: true,
            width: "150px",
        },
        {
            name: "User Mobile",
            selector: (row) => row.user_mobile || "N/A",
            sortable: true,
            width: "130px",
        },
        ...(1 === 1 ? [
            {
                name: "Address",
                selector: (row) => row.gift_deliver_address || "N/A",
                sortable: true,
                wrap: true,
                width: "200px",
            },
            {
                name: "Map",
                cell: (row) => (row.gift_deliver_address || row.lat) ? (
                    <button
                        onClick={() => setMapModal({ open: true, address: row.gift_deliver_address || "", name: row.user_name || "Location", lat: row.lat ?? null, lng: row.long ?? null })}
                        style={{
                            background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                            border: "none",
                            borderRadius: 8,
                            padding: "5px 10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            color: "white",
                            fontSize: 12,
                            fontWeight: 600,
                            transition: "opacity 0.2s",
                        }}
                        onMouseOver={e => e.currentTarget.style.opacity = "0.8"}
                        onMouseOut={e => e.currentTarget.style.opacity = "1"}
                        title="View on map"
                    >
                        <FaMapMarkerAlt /> Map
                    </button>
                ) : <span style={{ color: "#94a3b8", fontSize: 12 }}>N/A</span>,
                width: "90px",
                ignoreRowClick: true,
            }
        ] : []),
        ...(activeTab === "Points" ? [
            {
                name: "Points",
                selector: (row) => row.reward_price || "0",
                sortable: true,
                width: "100px",
            }
        ] : []),
        ...(activeTab === "Cashback" ? [
            {
                name: "Beneficiary ID",
                selector: (row) => row.cash_upi_address || "N/A",
                sortable: true,
                width: "150px",
            }
        ] : []),
        {
            name: "Warranty PDF",
            cell: (row) => row.warranty_pdf ? (
                <a href={row.warranty_pdf} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 underline">
                    View PDF
                </a>
            ) : "N/A",
            width: "120px",
        },
        {
            name: "Status",
            cell: (row) => {
                let statusText = "Pending";
                let statusClass = "bg-yellow-100 text-yellow-800";

                if (row.status === "0") {
                    statusText = "Approved";
                    statusClass = "bg-green-100 text-green-800";
                } else if (row.status === "1") {
                    statusText = "Pending";
                    statusClass = "bg-yellow-100 text-yellow-800";
                } else if (row.status === "2") {
                    statusText = "Rejected";
                    statusClass = "bg-red-100 text-red-800";
                } else if (row.status === "3") {
                    statusText = "Delivered";
                    statusClass = "bg-indigo-100 text-indigo-800";
                } else if (row.status === "4") {
                    statusText = "In Transit";
                    statusClass = "bg-blue-100 text-blue-800";
                }

                return (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusClass}`}>
                        {statusText}
                    </span>
                );
            },
            sortable: true,
            width: "100px",
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex gap-2 flex-wrap">
                    {row.status === "1" && (
                        <>
                            <button
                                onClick={() => handleApprove(row)}
                                className="px-2 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors"
                            >
                                Approve
                            </button>
                            <button
                                onClick={() => handleUpdateStatus(row.id, 2)}
                                className="px-2 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700 transition-colors"
                            >
                                Reject
                            </button>
                        </>
                    )}
                    {activeTab === "Gift" && row.status === "0" && (
                        <>
                            <button
                                onClick={() => handleUpdateStatus(row.id, 4)}
                                className="px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors"
                            >
                                In Transit
                            </button>
                            <button
                                onClick={() => handleUpdateStatus(row.id, 3)}
                                className="px-2 py-1 bg-indigo-600 text-white rounded text-xs hover:bg-indigo-700 transition-colors"
                            >
                                Delivered
                            </button>
                        </>
                    )}
                    {activeTab === "Gift" && row.status === "4" && (
                        <button
                            onClick={() => handleUpdateStatus(row.id, 3)}
                            className="px-2 py-1 bg-indigo-600 text-white rounded text-xs hover:bg-indigo-700 transition-colors"
                        >
                            Delivered
                        </button>
                    )}
                </div>
            ),
            width: "180px",
        },
        {
            name: "Won Date",
            selector: (row) => new Date(row.created_at).toLocaleString(),
            sortable: true,
            width: "200px",
        },
    ];

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1); // Reset to first page when searching
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    const handleCampaignChange = (e) => {
        setCampaignId(e.target.value);
        setPage(1); // Reset to first page when campaign changes
    };

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
        setPage(1);
    };

    return (
        <div className="p-6">

            {/* Photo Modal */}
            {photoModal.open && (
                <div
                    onClick={() => setPhotoModal({ open: false, url: "", name: "" })}
                    style={{
                        position: "fixed", inset: 0, zIndex: 1000,
                        background: "rgba(0,0,0,0.75)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        backdropFilter: "blur(4px)",
                    }}
                >
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: 16,
                            padding: 24,
                            maxWidth: 420,
                            width: "90%",
                            boxShadow: "0 25px 60px rgba(0,0,0,0.4)",
                            position: "relative",
                            textAlign: "center",
                        }}
                    >
                        <button
                            onClick={() => setPhotoModal({ open: false, url: "", name: "" })}
                            style={{
                                position: "absolute", top: 12, right: 12,
                                background: "#f1f5f9", border: "none", borderRadius: "50%",
                                width: 32, height: 32, cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 16, color: "#64748b",
                            }}
                        >
                            <FaTimes />
                        </button>
                        <p style={{ fontWeight: 700, fontSize: 16, color: "#1e1b4b", marginBottom: 16 }}>
                            {photoModal.name}'s Selfie
                        </p>
                        <img
                            src={photoModal.url}
                            alt={photoModal.name}
                            style={{
                                width: "100%",
                                maxHeight: 360,
                                objectFit: "contain",
                                borderRadius: 12,
                                border: "3px solid #e0e7ff",
                            }}
                        />
                    </div>
                </div>
            )}

            {/* Map Modal */}
            {mapModal.open && (
                <div
                    onClick={() => setMapModal({ open: false, address: "", name: "" })}
                    style={{
                        position: "fixed", inset: 0, zIndex: 1000,
                        background: "rgba(0,0,0,0.75)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        backdropFilter: "blur(4px)",
                    }}
                >
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: 16,
                            padding: 20,
                            width: "90%",
                            maxWidth: 640,
                            boxShadow: "0 25px 60px rgba(0,0,0,0.4)",
                            position: "relative",
                        }}
                    >
                        <button
                            onClick={() => setMapModal({ open: false, address: "", name: "" })}
                            style={{
                                position: "absolute", top: 12, right: 12,
                                background: "#f1f5f9", border: "none", borderRadius: "50%",
                                width: 32, height: 32, cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 16, color: "#64748b", zIndex: 10,
                            }}
                        >
                            <FaTimes />
                        </button>
                        <p style={{ fontWeight: 700, fontSize: 15, color: "#1e1b4b", marginBottom: 4, paddingRight: 40 }}>
                            <FaMapMarkerAlt style={{ color: "#6366f1", marginRight: 6, display: "inline" }} />
                            {mapModal.name}
                        </p>
                        {mapModal.address && (
                            <p style={{ fontSize: 12, color: "#64748b", marginBottom: 12 }}>{mapModal.address}</p>
                        )}
                        {mapModal.lat && mapModal.lng ? (
                            <>
                                <p style={{ fontSize: 11, color: "#94a3b8", marginBottom: 10, fontFamily: "monospace" }}>
                                    📍 {mapModal.lat}, {mapModal.lng}
                                </p>
                                <iframe
                                    title="delivery-map"
                                    width="100%"
                                    height="340"
                                    style={{ border: 0, borderRadius: 10 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src={`https://maps.google.com/maps?q=${mapModal.lat},${mapModal.lng}&output=embed&z=15`}
                                />
                                <a
                                    href={`https://www.google.com/maps?q=${mapModal.lat},${mapModal.lng}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-block", marginTop: 12,
                                        fontSize: 13, color: "#6366f1", fontWeight: 600,
                                        textDecoration: "underline",
                                    }}
                                >
                                    Open in Google Maps ↗
                                </a>
                            </>
                        ) : mapModal.address ? (
                            <>
                                <iframe
                                    title="delivery-map"
                                    width="100%"
                                    height="340"
                                    style={{ border: 0, borderRadius: 10 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src={`https://maps.google.com/maps?q=${encodeURIComponent(mapModal.address)}&output=embed&z=14`}
                                />
                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapModal.address)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-block", marginTop: 12,
                                        fontSize: 13, color: "#6366f1", fontWeight: 600,
                                        textDecoration: "underline",
                                    }}
                                >
                                    Open in Google Maps ↗
                                </a>
                            </>
                        ) : (
                            <p style={{ color: "#94a3b8", fontSize: 13, textAlign: "center", padding: "40px 0" }}>No location data available</p>
                        )}
                    </div>
                </div>
            )}

            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <FaGift className="text-indigo-600" />
                    Wheel Rewards Won
                </h1>

                {/* Tabs */}
                <div className="flex space-x-1 bg-indigo-50 p-1 rounded-lg mb-6 w-fit">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => handleTabChange(tab.name)}
                            className={`px-6 py-2 text-sm font-medium rounded-md transition-all duration-200 ${activeTab === tab.name
                                ? "bg-indigo-600 text-white shadow-sm"
                                : "text-indigo-600 hover:bg-indigo-100"
                                }`}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>

                {/* Filters */}
                <div className="bg-white rounded-lg shadow-md p-4 mb-6">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        {/* Campaign ID Filter */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Campaign ID
                            </label>
                            <input
                                type="number"
                                value={campaignId}
                                onChange={handleCampaignChange}
                                placeholder="Enter Campaign ID (optional)"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>

                        {/* Status Filter */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status
                            </label>
                            <select
                                value={filteredStatus}
                                onChange={(e) => {
                                    setFilteredStatus(e.target.value);
                                    setPage(1);
                                }}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                                <option value="">All Statuses</option>
                                <option value="1">Pending</option>
                                <option value="0">Approved</option>
                                <option value="2">Rejected</option>
                                <option value="4">In Transit</option>
                                <option value="3">Delivered</option>
                            </select>
                        </div>

                        {/* Search */}
                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Search
                            </label>
                            <div className="relative">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={handleSearch}
                                    placeholder="Search by reward name, user name, or mobile..."
                                    className="w-full px-3 py-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                />
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <FaSearch className="text-gray-400" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Data Table */}
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                    {isLoading ? (
                        <div className="flex justify-center items-center p-8">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                            <span className="ml-3">Loading...</span>
                        </div>
                    ) : error ? (
                        <div className="p-8 text-center">
                            <div className="text-red-600 mb-2">Error loading data</div>
                            <button
                                onClick={refetch}
                                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                            >
                                Retry
                            </button>
                        </div>
                    ) : (
                        <DataTableComponent
                            columns={columns}
                            data={rewardsWonData?.body?.data || []}
                            totalRows={rewardsWonData?.body?.pagination?.total || 0}
                            paginationPerPage={limit}
                            handlePageChange={handlePageChange}
                            handlePerRowsChange={handlePerRowsChange}
                            emptyMessage="No rewards won found"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WheelRewardsWon;